import { render, staticRenderFns } from "./TheExtraSns.vue?vue&type=template&id=55ae1dac&"
import script from "./TheExtraSns.vue?vue&type=script&lang=js&"
export * from "./TheExtraSns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports